import { Modal } from "@mantine/core";
import { imageBaseUrl } from "../../utilities/constants";

const G = {
  black: "#0d0d0d",
  charcoal: "#1c1c1c",
  silver: "#b0b0b0",
  white: "#ffffff",
  dark: "#2a2a2a",
  mid: "#4a4a4a",
  muted: "#888888",
  cream: "#f7f4ef",
};

const socials = [
  {
    label: "Instagram",
    href: "#",
    icon: (
      <svg
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#888'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <rect x='2' y='2' width='20' height='20' rx='5' />
        <circle cx='12' cy='12' r='4.5' />
        <circle cx='17.5' cy='6.5' r='1' fill='#888' stroke='none' />
      </svg>
    ),
  },
  {
    label: "Facebook",
    href: "#",
    icon: (
      <svg
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#888'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' />
      </svg>
    ),
  },
  {
    label: "TikTok",
    href: "#",
    icon: (
      <svg width='18' height='18' viewBox='0 0 24 24' fill='#888'>
        <path d='M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z' />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "#",
    icon: (
      <svg
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#888'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z' />
        <polygon
          points='9.75 15.02 15.5 12 9.75 8.98 9.75 15.02'
          fill='#888'
          stroke='none'
        />
      </svg>
    ),
  },
];

const EmailTemplatePreview = ({
  opened,
  setOpend,
  block = {},
  loading,
  appName = "Demo Name",
}) => {
  const close = () => setOpend(false);
  return (
    <Modal
      centered
      opened={opened}
      onClose={close}
      title='Email Template'
      overlayProps={{ backgroundOpacity: 0.3 }}
      zIndex={999}
      size='full'
    >
      <div
        style={{
          width: 600,
          margin: "0 auto",
          fontFamily: "Arial, sans-serif",
          fontSize: 13,
          color: "#333",
          background: "#ffffff",
          borderRadius: 4,
          overflow: "hidden",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {loading ? (
          <p style={{ textAlign: "center", padding: "32px 0" }}>Loading...</p>
        ) : block?.html ? (
          <iframe
            srcDoc={block.html}
            title="Email Preview"
            style={{ width: "100%", minHeight: 600, border: "none", display: "block" }}
          />
        ) : (
          <>
            {/* Header */}
            <div style={{ background: G.white, padding: "22px 40px 18px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 14,
                }}
              >
                <img
                  src={`/image.png`}
                  alt='Thumbnail'
                  className='w-[80px] h-[60px] mx-auto'
                />
                {/* <img
                  src={`https://dqr3i089ew1e2.cloudfront.net/assets/logo/template-logo2.png`}
                  alt='Thumbnail'
                  className='w-[150px] h-[120px]'
                /> */}

                {/* <div>
                  <div
                    style={{
                      color: "#C00000",
                      fontSize: 22,
                      fontWeight: 900,
                      fontFamily: "'Arial Black',Arial,sans-serif",
                      letterSpacing: 3,
                      lineHeight: 1,
                    }}
                  >
                    AMANI
                  </div>
                  <div
                    style={{
                      color: G.silver,
                      fontSize: 11,
                      letterSpacing: 6,
                      fontFamily: "'Helvetica Neue',Arial,sans-serif",
                      marginTop: 2,
                    }}
                  >
                    FORGED
                  </div>
                </div> */}
              </div>
              <div style={{ height: 1, background: "#C00000", opacity: 0.5 }} />
            </div>

            {/* Blocks */}
            <div style={{ padding: "20px 40px" }}>
              {block?.blocks?.map((b) => {
                const value = b?.value ?? "";
                const text = b?.text ?? "";
                const styles = b?.styles || {};

                if (b.type === "image") {
                  const src = value.startsWith("http")
                    ? value
                    : `${imageBaseUrl}/${value}`;
                  return (
                    <div
                      key={b.id}
                      style={{ textAlign: "center", margin: "20px 0" }}
                    >
                      <img
                        src={src}
                        alt='Email visual'
                        style={{
                          maxWidth: "100%",
                          height: "auto",
                          ...styles,
                        }}
                      />
                    </div>
                  );
                }

                if (b.type === "hr") {
                  return (
                    <hr
                      key={b.id}
                      style={{
                        margin: styles.margin || "16px 0",
                        border: styles.border || "1px solid #ccc",
                        width: styles.width || "100%",
                      }}
                    />
                  );
                }

                if (b.type === "link") {
                  return (
                    <div key={b.id} style={{ margin: "10px 0" }}>
                      <a
                        href={value}
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{
                          display: styles.display || "inline-block",
                          fontFamily: styles.fontFamily || "Arial, sans-serif",
                          fontSize: styles.fontSize || "13px",
                          fontWeight: styles.fontWeight || "normal",
                          color: styles.color || "#0000EE",
                          textDecoration: styles.textDecoration || "underline",
                          backgroundColor:
                            styles.backgroundColor || "transparent",
                          border: styles.border || "none",
                          borderRadius: styles.borderRadius || "4px",
                          padding: styles.padding || "10px 20px",
                          margin: styles.margin || "0",
                          lineHeight: styles.lineHeight || "1.5",
                          textAlign: styles.textAlign || "center",
                          width: styles.width,
                          height: styles.height,
                        }}
                      >
                        {text || value}
                      </a>
                    </div>
                  );
                }

                if (b.type === "rich") {
                  return (
                    <div
                      key={b.id}
                      style={{
                        display: styles.display || "block",
                        fontFamily: styles.fontFamily || "Arial, sans-serif",
                        fontSize: styles.fontSize || "13px",
                        fontWeight: styles.fontWeight || "normal",
                        color: styles.color || "#000",
                        textDecoration: styles.textDecoration || "none",
                        backgroundColor: styles.backgroundColor || "#fff",
                        border: styles.border || "none",
                        borderRadius: styles.borderRadius || "0px",
                        padding: styles.padding || "0px",
                        margin: styles.margin || "0px",
                        lineHeight: styles.lineHeight || "1.5",
                        textAlign: styles.textAlign || "left",
                      }}
                      dangerouslySetInnerHTML={{ __html: value }}
                    />
                  );
                }
                if (b.type === "p") {
                  return (
                    <div
                      key={b.id}
                      style={{
                        display: styles.display,
                        fontFamily: styles.fontFamily || "Arial, sans-serif",
                        fontSize: styles.fontSize || "13px",
                        fontWeight: styles.fontWeight || "normal",
                        color: styles.color || "#000",
                        textDecoration: styles.textDecoration || "none",
                        backgroundColor: styles.backgroundColor || "#fff",
                        border: styles.border || "none",
                        borderRadius: styles.borderRadius || "0px",
                        padding: styles.padding || "0px",
                        margin: styles.margin || "0px",
                        lineHeight: styles.lineHeight || "1.5",
                        textAlign: styles.textAlign || "left",
                        width: styles.width,
                        height: styles.height,
                      }}
                      dangerouslySetInnerHTML={{ __html: value }}
                    />
                  );
                }

                const Tag = b.type || "div";
                return (
                  <div key={b.id}>
                    <Tag
                      style={{
                        display: styles.display || "block",
                        fontFamily: styles.fontFamily || "Arial, sans-serif",
                        fontSize: styles.fontSize || "13px",
                        fontWeight: styles.fontWeight || "normal",
                        color: styles.color || "#000",
                        textDecoration: styles.textDecoration || "none",
                        backgroundColor: styles.backgroundColor || "#fff",
                        border: styles.border || "none",
                        borderRadius: styles.borderRadius || "0px",
                        padding: styles.padding || "0px",
                        margin: styles.margin || "0px",
                        lineHeight: styles.lineHeight || "1.5",
                        textAlign: styles.textAlign || "left",
                      }}
                      dangerouslySetInnerHTML={{ __html: value }}
                    />
                  </div>
                );
              })}
            </div>

            {/* Footer */}
            <div style={{ background: G.black }}>
              <div
                style={{ height: "0.5px", background: "#C00000", opacity: 0.4 }}
              />
              <div style={{ padding: "28px 40px 26px", textAlign: "center" }}>
                <div style={{ marginBottom: 6 }}>
                  <span
                    style={{
                      color: G.silver,
                      fontSize: 13,
                      letterSpacing: 4,
                      fontFamily: "'Arial Black',Arial,sans-serif",
                    }}
                  >
                    AMANI{" "}
                  </span>
                  <span
                    style={{
                      color: "#C00000",
                      fontSize: 13,
                      letterSpacing: 4,
                      fontFamily: "'Arial Black',Arial,sans-serif",
                    }}
                  >
                    FORGED
                  </span>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#b8b5b5",
                    fontFamily: "'Helvetica Neue',Arial,sans-serif",
                    letterSpacing: 0.4,
                    lineHeight: 1.7,
                    maxWidth: 400,
                    margin: "0 auto 20px",
                  }}
                >
                  The youngest multi-piece forged wheel line in the world —
                  manufactured &amp; assembled in the U.S.A.
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 14,
                    marginBottom: 20,
                  }}
                >
                  {socials.map((s) => (
                    <a
                      key={s.label}
                      href={s.href}
                      title={s.label}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 36,
                        height: 36,
                        border: "0.5px solid #333",
                        textDecoration: "none",
                      }}
                    >
                      {s.icon}
                    </a>
                  ))}
                </div>
                <div
                  style={{
                    height: "0.5px",
                    background: "#1e1e1e",
                    marginBottom: 16,
                  }}
                />
                <div
                  style={{
                    fontSize: 11,
                    color: "#b8b5b5",
                    fontFamily: "'Helvetica Neue',Arial,sans-serif",
                    marginBottom: 12,
                    lineHeight: 1.9,
                  }}
                >
                  support@amaniforged.com &nbsp;·&nbsp; amaniforged.com
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 20,
                    fontSize: 10,
                    letterSpacing: 1,
                    marginBottom: 14,
                  }}
                >
                  {["Privacy Policy", "Terms", "Unsubscribe"].map((l) => (
                    <a
                      key={l}
                      href='#'
                      style={{
                        color: "#b8b5b5",
                        textDecoration: "none",
                        fontFamily: "'Helvetica Neue',Arial,sans-serif",
                      }}
                    >
                      {l}
                    </a>
                  ))}
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#b8b5b5",
                    fontFamily: "'Helvetica Neue',Arial,sans-serif",
                  }}
                >
                  © {new Date().getFullYear()} Amani Forged. All rights
                  reserved.
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default EmailTemplatePreview;
